module.exports = __webpack_public_path__ + "static/media/neomix.1a978099.png";